/**
 * 내 품목 별 토글 — 호(또는 세번) 코드를 개인 즐겨찾기에 추가/제거.
 * 비로그인 시 숨김(서버가 401 이라 동작 불가).
 */
import React from "react";
import { Star } from "lucide-react";
import { useWatchlist } from "./watchlistApi";

export default function WatchStar({ code, name, label = true, size = 14 }) {
  const wl = useWatchlist();
  if (!wl.loggedIn || !code) return null;
  const on = wl.has(code);
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        wl.toggle(code, name);
      }}
      title={on ? "세번 즐겨찾기에서 제거" : "세번 즐겨찾기에 추가"}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        border: `1px solid ${on ? "var(--audit-accent)" : "var(--audit-border)"}`,
        background: on ? "var(--audit-accent)" : "var(--audit-bg)",
        color: on ? "#fff" : "var(--audit-text-muted)",
        borderRadius: 7,
        padding: label ? "5px 11px" : "5px 7px",
        fontSize: 12.5,
        fontWeight: 600,
        cursor: "pointer",
        fontFamily: "inherit",
      }}
    >
      <Star size={size} fill={on ? "currentColor" : "none"} />
      {label && (on ? "세번 즐겨찾기" : "즐겨찾기 추가")}
    </button>
  );
}
